import React from "react";
import PropTypes from "prop-types";

import { WithRenderTracking } from "components/DatadogTracker";
import { useFeatures } from "components/FeatureFlag";

import { UpgradeModal } from "..";

const UpgradeModalWithTracking = WithRenderTracking(
  UpgradeModal,
  "InsightsUpgradeModal"
);

function InsightsUpgradeModal({ message, onClose, ...props }) {
  const { resourceLink, defaultFormDescription } =
    useFeatures("insights-upgrade-plan") || {};

  return (
    <UpgradeModalWithTracking
      title="Upgrade to Enable Insights"
      upgradeSubject="Upgrade My Plan - Enable Insights"
      description={
        defaultFormDescription || "I am interested in the Insights feature."
      }
      onClose={onClose}
      message={
        <React.Fragment>
          {message && <div style={{ paddingBottom: "20px" }}>{message}</div>}
          Want to learn more about insights? Find videos and resources{" "}
          <a
            href={
              resourceLink ||
              "https://help.myhubly.com/en/collections/4196902-insight-dashboards"
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </React.Fragment>
      }
      {...props}
    />
  );
}

InsightsUpgradeModal.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

InsightsUpgradeModal.defaultProps = {
  message: undefined,
};

export default InsightsUpgradeModal;
